import "./index.scss";

import { CircularProgress, FormControl, InputLabel, Select, SelectProps } from "@mui/material";
import { ReactComponent as ArrowDownIcon } from "assets/images/square-buttons/chevron-down-green.svg";
import React, { FC, memo } from "react";

export interface DropdownProps extends SelectProps {
  loading?: boolean;
  selectedOptions?: any;
  customRenderItem?: (item: any, index: number) => React.ReactNode;
  showLabel?: boolean;
  shrink?: boolean;
  fullWidth?: boolean;
  containerClass?: string;
  className?: string;
}

const DropdownComponent: FC<DropdownProps> = (props) => {
  const {
    loading = false,
    label = "",
    showLabel = true,
    shrink = true,
    fullWidth,
    containerClass = "",
    ...restProps
  } = props;

  return (
    <FormControl fullWidth={fullWidth} className={containerClass}>
      {showLabel && <InputLabel>{label}</InputLabel>}
      <Select
        IconComponent={(props) =>
          loading ? (
            <CircularProgress disableShrink color="success" size={20} {...props} />
          ) : (
            <ArrowDownIcon className="arrow-icon" {...props} />
          )
        }
        {...restProps}
      />
    </FormControl>
  );
};

const Dropdown = memo(DropdownComponent);
export default Dropdown;
